import React from "react";
import { Image } from "@openedx/paragon";
import PropTypes from "prop-types";

// Resim import yolunuzun doğru olduğundan emin olun.
// Örnek kodunuzdaki yolu koruyorum.
import hero from "./authn-hero.jpg";
import logo from "../assets/logo.png";

import poweredLogo from "../assets/powered-by.png";

const ClIENT_URL = "https://sektorkampuste.milliteknolojiakademisi.gov.tr/";

const BaseContainer = ({ children, showWelcomeBanner, fullName }) => {
  return (
    <>
      <div className="container-fluid p-0">
        <div className="row min-vh-100 m-0">
          {/*
            Sol Kolon (Resim Alanı)
            - position-relative: İçerideki absolute katmanları kapsamak için eklendi.
            - overflow-hidden: Blur efektinin dışarı taşmasını engellemek için eklendi.
          */}
          <div className="d-none col-xl-7 d-xl-block p-0 box-shadow-right-1 position-relative overflow-hidden">
            {/*
              KATMAN 0: Ana Resim
              En altta durması için zIndex: 0 verildi.
            */}
            <Image
              className="h-100 w-100 position-absolute"
              alt={"hero"}
              src={hero}
              style={{ objectFit: "cover", zIndex: 0 }}
            />

            <div
              className="position-absolute top-0 left-0"
              style={{ zIndex: 999, padding: 20 }}
            >
              <a
                href={
                  ClIENT_URL ||
                  "https://sektorkampuste.milliteknolojiakademisi.gov.tr/"
                }
              >
                <Image
                  src={logo}
                  alt="Milli Teknoloji Akademisi"
                  style={{
                    maxHeight: "50px",
                    filter: "brightness(0) invert(1)",
                  }}
                />
              </a>
            </div>

            {/*
              KATMAN 1: Mavi Blur Filtresi (#005FFF33 ve blur:320px)
              - backdropFilter: Bu katmanın arkasındaki görüntüyü bulanıklaştırır.
              - backgroundColor: Yarı saydam mavi rengi verir.
            */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                backgroundColor: "rgb(0 20 255 / 50%)", // İstenilen mavi renk ve opaklık
                zIndex: 1, // Resmin üzerinde
                pointerEvents: "none", // Tıklamaların alta geçmesine izin verir (opsiyonel)
                mixBlendMode: "color-dodge"
              }}
            ></div>

            {/*
              KATMAN 2: Koyu Üst Filtre (#11182799)
              En üstte durarak son karartma efektini verir.
            */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                backgroundColor: "rgba(17, 24, 39, 0.4)", // İstenilen koyu renk ve opaklık
                zIndex: 2, // Mavi blur katmanının üzerinde
                pointerEvents: "none",
                mixBlendMode: "multiply"
              }}
            ></div>
          </div>

          {/* Sağ Kolon (İçerik Alanı) */}
          <div className="col-xl-5 d-flex align-items-center ms-auto p-0">
            <div className="col-12 d-flex justify-content-center">
              {children}
            </div>

            {/* Powered by Logo alanı) */}
            <a
              className="fixed-bottom"
              style={{ zIndex: 999, padding: 20, maxWidth: 135, left: "unset" }}
              href={"https://eduvence.com/"}
              target="_blank"
            >
              <Image
                className="h-100 w-100"
                alt={"hero"}
                src={poweredLogo}
                style={{ objectFit: "cover", zIndex: 0}}
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

BaseContainer.defaultProps = {
  showWelcomeBanner: false,
  fullName: null,
};

BaseContainer.propTypes = {
  children: PropTypes.node.isRequired,
  showWelcomeBanner: PropTypes.bool,
  fullName: PropTypes.string,
};

export default BaseContainer;
